/**
 * Created by sagardesai on 10/07/18.
 */

import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    favouritesList: null,
    favourite_unfavourite_data: null
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.FAVOURITES_LIST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.FAVOURITES_LIST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                favouritesList: action.payload
            };
        case types.FAVOURITES_LIST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                favouritesList: action.payload.error,
            };
        case types.RESET_FAVOURITES_LIST:
            return {
                ...state,
                favouritesList: action.payload,
            };
        case types.FAVOURITE_UNFAVOURITE_VIEWER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.FAVOURITE_UNFAVOURITE_VIEWER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                favourite_unfavourite_data: action.payload
            };
        case types.FAVOURITE_UNFAVOURITE_VIEWER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                favourite_unfavourite_data: action.payload.error,
            };
        case types.RESET_FAVOURITE_UNFAVOURITE_VIEWER:
            return {
                ...state,
                favourite_unfavourite_data: action.payload,
            };
        case types.SET_SEARCH_FAVOURITES_STATE:
            return {
                ...state,
                performSearch: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}